import { useHistory } from "react-router";
import { StyledSpan } from "../../styled";
import { Button, Icon } from "../atoms";
import { ActivityView } from "../organisms/ActivityView/ActivityView";
import { ModalView } from "../organisms/Modal/Modal";
import { useDispatch } from "react-redux";
import { SetRedirectURL } from "../../store/actions/kyc/KYCActions";
import { useTranslation } from "react-i18next";

interface Props {
  show: boolean;
  onClose: () => void;
  isMobile?: boolean;
}

const UseShowKyc = (props: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const GoToKyc = () => {

    props.onClose();

    setTimeout(() => {
      dispatch(SetRedirectURL(history.location.pathname));
      history.push("/kyc");
    }, 100);
  };
  
  const {t} = useTranslation();

  return (
    <>
      {!props.isMobile ? (
        <ModalView
          handleClose={() => props.onClose()}
          show={props.show}
          width="374px"
          height="362px"
          color="Light6"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              height: "100%",
              justifyContent: "space-between",
              padding: "16px",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <div
                style={{
                  width: "24px",
                  height: "24px",
                  background: "#35373D",
                  color: "bgPrimary",
                  borderRadius: "50%",
                  //   paddingTop: "2px",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                }}
                onClick={() => props.onClose()}
              >
                X
              </div>
            </div>
            <div>
              <Icon name="greenFace" width="110px" height="100px" />
            </div>
            <StyledSpan color="white" fontSize="16px" lineHeight="19px">
              {t("kyc.useShow.title")}
            </StyledSpan>
            <StyledSpan
              color="white"
              lineHeight="16px"
              customStyle={"width: 80%; text-align: center;"}
            >{t("kyc.useShow.p")}
            </StyledSpan>
            <Button
              id="100"
              text={t("kyc.useShow.btn")}
              primary={true}
              color="white"
              backgroundColor="bgPrimary"
              onClick={GoToKyc}
            ></Button>
          </div>
        </ModalView>
      ) : (
        <>
          {props.show && (
            <div>
              <ActivityView
                onClose={() => props.onClose()}
                roundedTop={true}
                show={props.show}
                dim={"wallet"}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "100%",
                    justifyContent: "space-between",
                    padding: "16px",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        width: "24px",
                        height: "24px",
                        background: "#35373D",
                        color: "bgPrimary",
                        borderRadius: "50%",
                        //   paddingTop: "2px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                      }}
                      onClick={() => props.onClose()}
                    >
                      X
                    </div>
                  </div>
                  <div>
                    <Icon name="greenFace" width="110px" height="100px" />
                  </div>
                  <StyledSpan color="white" fontSize="16px" lineHeight="19px">
                  {t("kyc.useShow.title")}
                  </StyledSpan>
                  <StyledSpan
                    color="white"
                    lineHeight="16px"
                    customStyle={"width: 80%; text-align: center;"}
                  >{t("kyc.useShow.p")}
                  </StyledSpan>
                  <Button
                    id="101"
                    text={t("kyc.useShow.btn")}
                    primary={true}
                    color="white"
                    backgroundColor="bgPrimary"
                    onClick={GoToKyc}
                  ></Button>
                </div>
              </ActivityView>
            </div>
          )}
        </>
      )}
    </>
  );
};
export default UseShowKyc;
